(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stitchd-all-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.stitchd-all-reviews');

    roots.forEach((root) => {
      if (root.dataset.stitchdReviewBound === 'true') return;
      root.dataset.stitchdReviewBound = 'true';

      const reviews = [...root.querySelectorAll('.jdgm-all-reviews__body .jdgm-rev')];
      const button = root.querySelector('[data-stitchd-reviews-toggle]');
      const initialCount = 6;

      if (!button || reviews.length <= initialCount) return;

      reviews.slice(initialCount).forEach((review) => {
        review.classList.add('stitchd-review-hidden');
      });

      button.hidden = false;

      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';

        reviews.slice(initialCount).forEach((review) => {
          review.classList.toggle('stitchd-review-hidden', expanded);
        });

        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        button.textContent = expanded ? 'See more reviews' : 'Show fewer';

        if (expanded) {
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stitchd-conversion-9-9-pop-up"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = [...document.querySelectorAll('[data-st99-root]')];

    roots.forEach((root) => {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      const dialog = root.querySelector('[data-st99-dialog]');
      const closeButton = root.querySelector('[data-st99-close]');
      const cta = root.querySelector('[data-st99-cta]');
      const enabled = root.dataset.enabled === 'true' && !window.location.pathname.endsWith('/products/11-11-mega-bundle') && !window.location.pathname.startsWith('/cart') ;
      const seenKey = 'stitchd1111LandingPopupSeen';

      const readSession = (key) => {
        try {
          return sessionStorage.getItem(key);
        } catch (error) {
          return null;
        }
      };

      const writeSession = (key, value) => {
        try {
          sessionStorage.setItem(key, value);
        } catch (error) {}
      };

      const track = (eventName, reason) => {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: eventName,
          stitchd_popup_reason: reason
        });
      };

      const close = () => {
        if (dialog.open) dialog.close();
        track('stitchd_1111_popup_close', 'first-landing');
      };

      closeButton.addEventListener('click', close);

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        close();
      });

      cta.addEventListener('click', () => {
        track('stitchd_1111_popup_claim', 'first-landing');
      });

      if (!enabled || !dialog || readSession(seenKey)) return;

      writeSession(seenKey, String(Date.now()));
      dialog.dataset.reason = 'first-landing';
      dialog.showModal();

      window.setTimeout(() => {
        cta.focus();
      }, 80);

      track('stitchd_1111_popup_view', 'first-landing');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stitchd-keychain-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('stitchd-keychain-product'))customElements.define('stitchd-keychain-product',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;this.classList.add('is-ready');
    const form=this.querySelector('form'),cards=[...this.querySelectorAll('[data-design]')],inputs=[...this.querySelectorAll('[data-variant-qty]')],buttons=[...this.querySelectorAll('[data-submit]')],message=this.querySelector('[data-message]'),photo=this.querySelector('.skp-main-image'),sticky=this.querySelector('.skp-sticky');
    let busy=false,actionsVisible=true,count=0;
    const money=n=>new Intl.NumberFormat(this.dataset.locale||'en',{style:'currency',currency:this.dataset.currency||'PKR',maximumFractionDigits:0}).format(n/100);
    const tierFor=n=>n>=12?10:n>=10?7:n>=8?5:0;
    const nextText=n=>n<6?`Add ${6-n} more to unlock free shipping.`:n<8?`Free shipping unlocked · add ${8-n} more to save 5%.`:n<10?`5% + free shipping unlocked · add ${10-n} more to save 7%.`:n<12?`7% + free shipping unlocked · add ${12-n} more to save 10%.`:`Best deal unlocked · 10% off + free shipping.`;
    const update=()=>{
      count=0;let total=0;
      inputs.forEach(input=>{const n=Math.max(0,Math.floor(Number(input.value)||0));input.value=String(n);const card=input.closest('[data-design]');card.classList.toggle('is-selected',n>0);count+=n;total+=n*Number(card.dataset.price)});
      const pct=tierFor(count),saving=Math.round(total*pct/100),after=total-saving;
      this.querySelectorAll('[data-selection-count]').forEach(el=>el.textContent=count+' '+this.dataset.selectedLabel);
      this.querySelectorAll('[data-selection-total]').forEach(el=>el.textContent=money(after));
      const before=this.querySelector('[data-before-total]');if(before){before.hidden=!pct;before.textContent=pct?money(total):'';}
      const savingCopy=this.querySelector('[data-saving-copy]');if(savingCopy)savingCopy.textContent=pct?`Estimated ${pct}% saving: ${money(saving)}`:(count>=6?'Free shipping unlocked':'No percentage discount yet');
      const fill=this.querySelector('[data-progress-fill]');if(fill)fill.style.width=Math.min(100,count/12*100)+'%';
      const label=this.querySelector('[data-progress-label]');if(label)label.textContent=Math.min(count,12)+' / 12';
      this.querySelectorAll('[data-milestone]').forEach(el=>el.classList.toggle('is-hit',count>=Number(el.dataset.milestone)));
      this.querySelectorAll('[data-reward]').forEach(el=>el.classList.toggle('is-hit',count>=Number(el.dataset.reward)));
      const next=this.querySelector('[data-next-reward]');if(next)next.textContent=nextText(count);
      buttons.forEach(b=>{b.disabled=busy||count===0;b.textContent=count===0?this.dataset.choose:b.name==='checkout'?this.dataset.buy:this.dataset.add});
      sticky.classList.toggle('is-visible',count>0&&!actionsVisible);
    };
    this.querySelectorAll('[data-step]').forEach(b=>b.addEventListener('click',()=>{const input=b.closest('[data-design]').querySelector('input');input.value=String(Math.max(0,(Number(input.value)||0)+Number(b.dataset.step)));update()}));
    inputs.forEach(input=>input.addEventListener('change',update));
    this.querySelector('[data-clear]')?.addEventListener('click',()=>{inputs.forEach(i=>i.value='0');update()});
    this.querySelector('[data-search]')?.addEventListener('input',e=>{const term=e.target.value.trim().toLowerCase();let visible=0;cards.forEach(c=>{c.hidden=!c.dataset.name.toLowerCase().includes(term);if(!c.hidden)visible++});this.querySelector('.skp-no-results').hidden=visible>0});
    this.querySelectorAll('[data-photo]').forEach(b=>b.addEventListener('click',()=>{if(!photo)return;photo.removeAttribute('srcset');photo.src=b.dataset.photo;photo.alt=b.dataset.photoAlt||'';if(matchMedia('(max-width:749px)').matches)photo.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})}));
    form.addEventListener('submit',async e=>{e.preventDefault();update();if(busy||!count||!form.reportValidity())return;const checkout=e.submitter?.name==='checkout',items=inputs.filter(i=>Number(i.value)>0).map(i=>({id:i.dataset.variantQty,quantity:Number(i.value)}));busy=true;update();message.textContent=this.dataset.adding;this.querySelector('.skp-success').hidden=true;try{const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw new Error(result.description||this.dataset.error);if(checkout){location.assign(this.dataset.root+'checkout');return;}message.textContent=this.dataset.added;this.querySelector('.skp-success').hidden=false;inputs.forEach(i=>i.value='0');fetch(this.dataset.root+'cart.js').then(r=>r.json()).then(cart=>{document.querySelectorAll('.cart-count-bubble span[aria-hidden=true]').forEach(el=>el.textContent=cart.item_count)}).catch(()=>{});}catch(error){message.textContent=error.message||this.dataset.error;}finally{busy=false;update();}});
    this.observer=new IntersectionObserver(entries=>{actionsVisible=entries[0].isIntersecting;update()},{threshold:0});this.observer.observe(this.querySelector('.skp-actions'));update();
  }
  disconnectedCallback(){this.observer?.disconnect();}
});

  } catch(e) { console.error(e); }
})();
})();
